export class MobileConsole {
    private logs: string = '';
    private readonly el: HTMLDivElement;
    private readonly logsEl: HTMLDivElement;
    private readonly input: HTMLInputElement;

    constructor() {
        this.el = document.createElement('div') as HTMLDivElement;
        this.el.style.overflow = 'auto';
        this.el.style.position = 'absolute';
        this.el.style.backgroundColor = 'rgba(0,0,0,0.6)';
        document.body.appendChild(this.el);

        this.el.innerHTML = `
      <div id="mobileConsoleButtons" style="position: fixed">
        <input id="mobileConsoleInput" type="text" />
        <input id="mobileConsoleEnter" type="button" value=">" />
        <input id="mobileConsoleClear" type="button" value="Clear" />
        <input id="mobileConsoleClose" type="button" value="Close" />
      </div>
      <pre id="mobileConsoleLogs" style="margin-top: 20px"></pre>
    `;

        this.logsEl = document.getElementById('mobileConsoleLogs') as HTMLDivElement;

        const closeButton = document.getElementById('mobileConsoleClose') as HTMLInputElement;
        closeButton.addEventListener('pointerdown', () => {
            this.visible = false;
        });

        const clearButton = document.getElementById('mobileConsoleClear') as HTMLInputElement;
        clearButton.addEventListener('pointerdown', this.clear);

        const consoleInput = document.getElementById('mobileConsoleInput') as HTMLInputElement;
        consoleInput.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() === 'enter') {
                this.handleEnterClick();
            }
        });
        this.input = consoleInput;

        const enterButton = document.getElementById('mobileConsoleEnter') as HTMLInputElement;
        enterButton.addEventListener('pointerdown', this.handleEnterClick);

        this.overwriteConsole();
        this.render();
        window.addEventListener('resize', this.render);
        this.visible = false;
    }

    private readonly handleEnterClick = (): void => {
        console.log(eval(this.input.value));
    };

    private overwriteConsole(): void {
        const log = console.log;
        const warn = console.warn;
        const error = console.error;
        const self = this;

        const addLogs = (
            args: (string | number | object)[],
            style: { color: string; bgColor: string } = { color: '#ffffff', bgColor: 'none' },
        ) => {
            const lines = args.flatMap((arg) => {
                arg = typeof arg === 'object' ? JSON.stringify(arg, null, 2) : arg;
                return String(arg).split('\n');
            });
            const s = `color: ${style.color}; background-color: ${style.bgColor}; padding: 2px 2px 2px 10px;`;
            self.logs += `<div style="${s}">${lines.join('<br />')}</div>`;
            self.render();
        };

        console.log = function (...args: any[]) {
            log.call(this, ...args);
            addLogs(args);
        };

        console.warn = function (...args: any[]) {
            warn.call(this, ...args);
            addLogs(args, { color: '#5C3C00', bgColor: '#FFFBE5' });
        };

        console.error = function (...args: any[]) {
            error.call(this, ...args);
            addLogs(args, { color: '#FF0000', bgColor: '#FFF0F0' });
        };
    }

    set visible(value: boolean) {
        this.el.style.display = value ? 'block' : 'none';
    }

    get visible(): boolean {
        return this.el.style.display === 'block';
    }

    private clear = (): void => {
        this.logs = '';
        this.render();
    };

    private render = (): void => {
        this.el.style.width = `${window.innerWidth}px`;
        this.el.style.height = `${window.innerHeight}px`;
        this.logsEl.style.height = `${window.innerHeight - 60}px`;
        this.logsEl.innerHTML = this.logs;
    };

    public prompt(text: string): void {
        this.visible = true;
        this.input.value = text;
    }
}
